export default {
  common: {
    brand: "USFans Spreadsheet",
    nav: {
      home: "Accueil",
      shoppingGuide: "Guide d'achat",
      spreadsheet: "Tableur",
      categories: "Catégories",
      resources: "Ressources",
      faq: "FAQ",
    },
    cta: {
      explore: "Explorer le tableur",
      buyNow: "Acheter maintenant",
      visitMain: "Visiter le site principal",
      readGuide: "Lire le guide complet",
    },
    categoriesTitle: "Acheter par catégorie",
    categoriesSubtitle: "Parcourez toutes les catégories de produits sur la boutique principale",
    browseCategories: "Parcourir les catégories",
    jumpCategory: "Aller à une catégorie",
    footer: {
      tagline: "Un centre de ressources indépendant sur le tableur USFans : guides, avis et conseils pratiques.",
      disclaimer: "Ceci est un site d'information indépendant, non affilié à USFans ni à la boutique principale. Les liens externes s'ouvrent dans un nouvel onglet.",
      resourcesTitle: "Ressources",
      categoriesTitle: "Catégories",
      legalTitle: "Mentions légales",
      rights: "Tous droits réservés.",
    },
    backHome: "Retour à l'accueil",
    published: "Publié",
    updated: "Dernière mise à jour",
    readMore: "Lire l'article",
    languageLabel: "Langue",
  },
};